export default __webpack_public_path__ + "static/media/Omkar.6e787571.mp3";